import { truncToFixed } from '@/utils'
import { date } from 'quasar'

export const getPricingAmounts = (_s) => {
  const _d = _s.dayPrice
  return {
    dayAmount: _d,
    nightAmount: truncToFixed(_d * _s.nightFactor),
    holidayAmount: truncToFixed(_d * _s.holidayFactor),
    holidayNightAmount: truncToFixed(_d * _s.holidayNightFactor),
    sundayAmount: truncToFixed(_d * _s.sundayFactor),
    sundayNightAmount: truncToFixed(_d * _s.sundayNightFactor),
    sundayHolidayAmount: truncToFixed(_d * _s.sundayHolidayFactor),
    sundayHolidayNightAmount: truncToFixed(_d * _s.sundayHolidayNightFactor),
    saturdayAmount: truncToFixed(_d * _s.saturdayFactor),
    saturdayNightAmount: truncToFixed(_d * _s.saturdayNightFactor),
    saturdayHolidayAmount: truncToFixed(_d * _s.saturdayHolidayFactor),
    saturdayHolidayNightAmount: truncToFixed(_d * _s.saturdayHolidayNightFactor)
  }
}

/**
 * Retourne le type de souscription agent
 * @param agent
 * @return {null|number}
 */
export const getAgentSubscriptionValue = (agent) => {
  const subscription = _.get(agent, ['agentInfos', 'subscription'])
  if (!subscription || !subscription.active || !agent.enabled) {
    return null
  }
  if (subscription.autoRenewal) {
    return 0
  }
  return date.getDateDiff(
    subscription.currentPeriodEndAt,
    subscription.currentPeriodStartAt,
    'days'
  )
}

/**
 * Calcule un pricing annuel avec un 1 mois offert
 * @param p
 * @return {{priceYearlyDiscount: string | number, priceYearly: string | number}}
 */
export const computeYearlyPricing = (p) => {
  const p12 = truncToFixed(p.price * 12)
  return {
    ...p,
    priceYearly: p12,
    priceYearlyDiscount: truncToFixed(p12 - p.price)
  }
}

/**
 * Calcule le pricing
 * @param agentsLimit
 * @param accountsLimit
 * @param countAgents
 * @return {{accountsCount: number, agentsLimit: *, agentsCount: *, accountsError: boolean, agentsError: boolean, accountsLimit: *}}
 */
export const computeQuotas = ({ agentsLimit = 0, accountsLimit = 0, countAgents = {} } = {}) => {
  return {
    agentsLimit,
    agentsCount: countAgents.agents,
    agentsError: agentsLimit <= countAgents.agents,
    accountsLimit,
    accountsCount: countAgents.accounts,
    accountsError: accountsLimit <= countAgents.accounts
  }
}
